import { ERROR_LIST } from 'src/app/core/constants/error-handling-list/error-list.enum';

export type ErrorKey = keyof typeof ERROR_LIST;

export const ERROR_IGNORE_LIST: ErrorKey[] = [
  'RECOGNITION_NOT_FOUND',
  'ISSUE_NOT_FOUND',
  'ROUND_NOT_FOUND',
  'ROUND_LOCKED_WHILE_AI_PROCESSING',
  'TEMPLATE_NOT_FOUND',
  'DISTRICT_UPDATE_SCHEDULED_ROUNDS_FORBIDDEN',
  'DISTRICT_UPDATE_NON_USER_ACCESS_FORBIDDEN',
  'SCHEDULED_ROUNDS_DISABLED',
];
